import React from "react";

const Loading = () => (
  <div className="loading-overlay">
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  </div>
);

export default Loading;
